import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import weekday from 'dayjs/plugin/weekday';
import isoWeek from 'dayjs/plugin/isoWeek';
import horoscopes from '~/static/json/horoscopes.json';
import { getDailyTarotUrl } from '~/modules/tarot/utils/tarotUtils';
dayjs.locale('tr');
dayjs.extend(weekday);
dayjs.extend(isoWeek);

export const isAstrolojiContent = process.client && document.location.pathname.startsWith('/astroloji/');

export const getPlanetName = (name) => {
  return natalPlanets[name] || name;
};

const natalPlanets = {
  Lilith: 'Lilith',
  Chiron: 'Şiron',
  Pluto: 'Plüton',
  Neptune: 'Neptün',
  Uranus: 'Uranüs',
  Saturn: 'Satürn',
  Jupiter: 'Jüpiter',
  Mars: 'Mars',
  Moon: 'Ay',
  Sun: 'Güneş',
  Mercury: 'Merkür',
  Venus: 'Venüs',
  NNode: 'Kuzey Düğümü',
  SNode: 'Güney Düğümü',
  Fortune: 'Fortuna',
};

export const horoscopeData = [
  {
    title: 'Koç',
    slug: 'aries',
    dates: '21 Mart - 20 Nisan',
    image: 'koc',
    text: 'Koç burcunun günlük yorumu',
  },
  {
    title: 'Boğa',
    slug: 'taurus',
    dates: '21 Nisan - 21 Mayıs',
    image: 'boga',
    text: 'Boğa burcunun günlük yorumu',
  },
  {
    title: 'İkizler',
    slug: 'gemini',
    dates: '22 Mayıs - 21 Haziran',
    image: 'ikizler',
    text: 'İkizler burcunun günlük yorumu',
  },
  {
    title: 'Yengeç',
    slug: 'cancer',
    dates: '22 Haziran - 22 Temmuz',
    image: 'yengec',
    text: 'Yengeç burcunun günlük yorumu',
  },
  {
    title: 'Aslan',
    slug: 'leo',
    dates: '23 Temmuz - 22 Ağustos',
    image: 'aslan',
    text: 'Aslan burcunun günlük yorumu',
  },
  {
    title: 'Başak',
    slug: 'virgo',
    dates: '23 Ağustos - 22 Eylül',
    image: 'basak',
    text: 'Başak burcunun günlük yorumu',
  },
  {
    title: 'Terazi',
    slug: 'libra',
    dates: '23 Eylül - 22 Ekim',
    image: 'terazi',
    text: 'Terazi burcunun günlük yorumu',
  },
  {
    title: 'Akrep',
    slug: 'scorpio',
    dates: '23 Ekim - 21 Kasım',
    image: 'akrep',
    text: 'Akrep burcunun günlük yorumu',
  },
  {
    title: 'Yay',
    slug: 'sagittarius',
    dates: '22 Kasım - 21 Aralık',
    image: 'yay',
    text: 'Yay burcunun günlük yorumu',
  },
  {
    title: 'Oğlak',
    slug: 'capricorn',
    dates: '22 Aralık - 19 Ocak',
    image: 'oglak',
    text: 'Oğlak burcunun günlük yorumu',
  },
  {
    title: 'Kova',
    slug: 'aquarius',
    dates: '20 Ocak - 18 Şubat',
    image: 'kova',
    text: 'Kova burcunun günlük yorumu',
  },
  {
    title: 'Balık',
    slug: 'pisces',
    dates: '19 Şubat - 20 Mart',
    image: 'balik',
    text: 'Balık burcunun günlük yorumu',
  },
];

// get horoscope types
export const horoscopeTypes = [
  { id: 'general', title: 'Genel' },
  { id: 'love', title: 'Aşk' },
  { id: 'money', title: 'Para' },
  { id: 'health', title: 'Sağlık' },
];

// get horoscope name
export const getHoroscopeName = (name) => {
  const horoscope = horoscopes.find((h) => h.slug === name || h['slug-en'] === name);
  return horoscope ? horoscope.name : name;
};

// get horoscope slug
export const getHoroscopeSlug = (name, lang) => {
  const horoscope = horoscopes.find((h) => h.name === name || h['slug-en'] === name || h.slug === name);
  return horoscope ? (lang === 'en' ? horoscope['slug-en'] : horoscope.slug) : name;
};

export const getHoroscopes = () => {
  return horoscopes.map((h) => ({
    name: h.name,
    slug: h.slug,
  }));
};

export const getAvailableFrequencies = (frequency) => {
  const allFrequencies = ['daily', 'weekly', 'monthly', 'yearly'];
  return allFrequencies.filter((freq) => freq !== frequency);
};

export const getVariant = (type) => {
  switch (type) {
    case 'general':
      return 'love';
    case 'love':
      return 'health';
    case 'health':
      return 'money';
    case 'money':
      return 'general';
    default:
      return 'general';
  }
};

// get date text
export const getDateText = (dateStr) => {
  // check date format
  if (!dateStr) return '';
  // YYYY format (only year)
  if (/^\d{4}$/.test(dateStr)) {
    return dateStr;
  }
  // MM.YYYY format (month and year)
  if (/^\d{2}\.\d{4}$/.test(dateStr)) {
    const [month, year] = dateStr.split('.');
    return dayjs(`${year}-${month}-01`).format('MMMM YYYY');
  }
  // date range check (DD.MM.YYYY-DD.MM.YYYY)
  if (dateStr.includes('-')) {
    const [startDate, endDate] = dateStr.split('-');
    const startDateObj = dayjs(startDate.split('.').reverse().join('-'));
    const endDateObj = dayjs(endDate.split('.').reverse().join('-'));
    // if same month and year
    if (startDateObj.format('MM YYYY') === endDateObj.format('MM YYYY')) {
      return `${startDateObj.format('D')} - ${endDateObj.format('D MMMM YYYY')}`;
    }
    return `${startDateObj.format('D MMMM YYYY')} - ${endDateObj.format('D MMMM YYYY')}`;
  }
  // single date (DD.MM.YYYY)
  const [day, month, year] = dateStr.split('.');
  return dayjs(`${year}-${month}-${day}`).format('D MMMM YYYY');
};

// convert horoscope name
const convertHoroscopeName = (name) => {
  const horoscopeMap = {
    koc: 'aries',
    boga: 'taurus',
    ikizler: 'gemini',
    yengec: 'cancer',
    aslan: 'leo',
    basak: 'virgo',
    terazi: 'libra',
    akrep: 'scorpio',
    yay: 'sagittarius',
    oglak: 'capricorn',
    kova: 'aquarius',
    balik: 'pisces',
  };
  return horoscopeMap[name] || name;
};

// convert horoscope type
const convertHoroscopeType = (name) => {
  const horoscopeMap = {
    genel: 'general',
    ask: 'love',
    para: 'money',
    saglik: 'health',
  };
  return horoscopeMap[name] || name;
};

export const getHoroscopeTypeText = (name) => {
  const horoscopeMap = {
    general: '',
    love: 'Aşk',
    money: 'Para',
    health: 'Sağlık',
  };
  return horoscopeMap[name];
};

// convert horoscope frequency
const convertHoroscopeFrequency = (name) => {
  const horoscopeMap = {
    gunluk: 'daily',
    haftalik: 'weekly',
    aylik: 'monthly',
    yillik: 'yearly',
  };
  return horoscopeMap[name] || name;
};

export const getFrequencyText = (name) => {
  const horoscopeMap = {
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    yearly: 'Yıllık',
  };
  return horoscopeMap[name] || name;
};

// convert month name to number
const convertMonthNameToNumber = (dateWithMonthName) => {
  const months = {
    ocak: '01',
    subat: '02',
    mart: '03',
    nisan: '04',
    mayis: '05',
    haziran: '06',
    temmuz: '07',
    agustos: '08',
    eylul: '09',
    ekim: '10',
    kasim: '11',
    aralik: '12',
  };

  // weekly format: "17-mart-2025-23-mart-2025"
  if (dateWithMonthName.includes('-') && dateWithMonthName.split('-').length >= 5) {
    const parts = dateWithMonthName.split('-');
    // example: 17-mart-2025-23-mart-2025
    const day1 = parts[0].padStart(2, '0');
    const month1 = months[parts[1]] || parts[1];
    const year1 = parts[2];
    const day2 = parts[3].padStart(2, '0');
    const month2 = months[parts[4]] || parts[4];
    const year2 = parts.length > 5 ? parts[5] : year1;

    return `${day1}.${month1}.${year1}-${day2}.${month2}.${year2}`;
  }

  // monthly format: "mart-2025"
  if (dateWithMonthName.includes('-') && dateWithMonthName.split('-').length === 2 && !dateWithMonthName.split('-')[0].match(/^\d+$/)) {
    const parts = dateWithMonthName.split('-');
    const month = months[parts[0]] || parts[0];
    const year = parts[1];

    return `${month}.${year}`;
  }

  // daily format: "18-mart-2025"
  if (dateWithMonthName.includes('-') && dateWithMonthName.split('-').length === 3) {
    const parts = dateWithMonthName.split('-');
    const day = parts[0].padStart(2, '0');
    const month = months[parts[1]] || parts[1];
    const year = parts[2];

    return `${day}.${month}.${year}`;
  }

  return dateWithMonthName;
};

// parse horoscope url
export const parseHoroscopeUrl = (url) => {
  // custom article url pattern
  if (url.includes('-burc-yorumuna-gore-')) {
    /* eslint-disable */
    const patternCustomArticle =
      /\/astroloji\/(?:([a-z]+)-([a-z]+)-burc-yorumuna|([a-z]+)-burc-yorumuna)-gore-([0-9]{1,2}-[a-z]+-[0-9]{4})/;

    const matchCustomArticle = url.match(patternCustomArticle);
    if (!matchCustomArticle) return null;

    const frequencyCustomArticle = matchCustomArticle[1] || matchCustomArticle[3];
    const typeCustomArticle = matchCustomArticle[2] || 'genel';
    const dateCustomArticle = matchCustomArticle[4];

    return {
      horoscope: 'all', // sabit
      date: convertMonthNameToNumber(dateCustomArticle),
      frequency: convertHoroscopeFrequency(frequencyCustomArticle),
      type: convertHoroscopeType(typeCustomArticle),
    };
  }

  /* eslint-disable */
  const pattern =
    /astroloji\/([^\/]+)\/(?:(\d{1,2}-(?:ocak|subat|mart|nisan|mayis|haziran|temmuz|agustos|eylul|ekim|kasim|aralik)-\d{4}(?:-\d{1,2}-(?:ocak|subat|mart|nisan|mayis|haziran|temmuz|agustos|eylul|ekim|kasim|aralik)-\d{4})?|(?:ocak|subat|mart|nisan|mayis|haziran|temmuz|agustos|eylul|ekim|kasim|aralik)-\d{4}|\d{4}))-(gunluk|haftalik|aylik|yillik)-(.+?)-yorumu/;

  const match = url.match(pattern);
  if (!match) return null;
  /* eslint-disable */
  const [_, horoscope, date, frequency, typeRaw] = match;
  if (!horoscope || !date || !frequency || !typeRaw) return null;
  let type = 'genel';
  if (typeRaw.includes('ask')) type = 'ask';
  if (typeRaw.includes('para')) type = 'para';
  if (typeRaw.includes('saglik')) type = 'saglik';

  return {
    horoscope: convertHoroscopeName(horoscope),
    date: convertMonthNameToNumber(date),
    frequency: convertHoroscopeFrequency(frequency),
    type: convertHoroscopeType(type),
  };
};

export const createHoroscopeUrl = ({ horoscope, date, frequency, type }) => {
  // Frequency mapping
  const frequencyMap = {
    daily: 'gunluk',
    weekly: 'haftalik',
    monthly: 'aylik',
    yearly: 'yillik',
  };

  // Type mapping
  const typeMap = {
    general: 'burc',
    love: 'ask-burc',
    money: 'para-burc',
    health: 'saglik-burc',
  };

  // Horoscope mapping
  const horoscopeMap = {
    aries: 'koc',
    taurus: 'boga',
    gemini: 'ikizler',
    cancer: 'yengec',
    leo: 'aslan',
    virgo: 'basak',
    libra: 'terazi',
    scorpio: 'akrep',
    sagittarius: 'yay',
    capricorn: 'oglak',
    aquarius: 'kova',
    pisces: 'balik',
  };

  if (!date) {
    date = dayjs().format('DD.MM.YYYY');
  }

  // convert month number to month name (MM.YYYY, DD.MM.YYYY, DD.MM.YYYY-DD.MM.YYYY format for)
  let formattedDate = date;

  // weekly format (DD.MM.YYYY-DD.MM.YYYY)
  if (frequency === 'weekly' && date.includes('-')) {
    const [startDate, endDate] = date.split('-');
    formattedDate = formatDateWithMonthName(startDate) + '-' + formatDateWithMonthName(endDate);
  }
  // monthly format (MM.YYYY)
  else if (frequency === 'monthly' && date.includes('.') && date.split('.').length === 2) {
    formattedDate = formatMonthYearWithName(date);
  }
  // daily format (DD.MM.YYYY)
  else if (frequency === 'daily' && date.includes('.')) {
    formattedDate = formatDateWithMonthName(date);
  }

  if (horoscope === 'all') {
    return `/astroloji/${frequencyMap[frequency]}-${typeMap[type]}-yorumuna-gore-${formattedDate}-gunun-nasil-gececek`;
  }

  return `/astroloji/${horoscopeMap[horoscope] || horoscope}/${formattedDate}-${frequencyMap[frequency]}-${typeMap[type]}-yorumu`;
};

// Helper functions
const formatDateWithMonthName = (dateStr) => {
  // convert DD.MM.YYYY to DD-MonthName-YYYY format
  const monthNames = {
    '01': 'ocak',
    '02': 'subat',
    '03': 'mart',
    '04': 'nisan',
    '05': 'mayis',
    '06': 'haziran',
    '07': 'temmuz',
    '08': 'agustos',
    '09': 'eylul',
    10: 'ekim',
    11: 'kasim',
    12: 'aralik',
  };

  const parts = dateStr.split('.');
  if (parts.length !== 3) return dateStr;

  const day = parseInt(parts[0], 10).toString(); // remove leading 0
  const month = monthNames[parts[1]];
  const year = parts[2];

  return `${day}-${month}-${year}`;
};

const formatMonthYearWithName = (dateStr) => {
  // convert MM.YYYY to MonthName-YYYY format
  const monthNames = {
    '01': 'ocak',
    '02': 'subat',
    '03': 'mart',
    '04': 'nisan',
    '05': 'mayis',
    '06': 'haziran',
    '07': 'temmuz',
    '08': 'agustos',
    '09': 'eylul',
    10: 'ekim',
    11: 'kasim',
    12: 'aralik',
  };

  const parts = dateStr.split('.');
  if (parts.length !== 2) return dateStr;

  const month = monthNames[parts[0]];
  const year = parts[1];

  return `${month}-${year}`;
};

// get week days
export const getWeekDays = (dateStr) => {
  let inputDate = dayjs(dateStr.split('.').reverse().join('-'));
  const today = dayjs();
  const currentHour = today.hour();

  // INFO: astroloji içeriklerinin başlangıç tarihi olarak YYYY-AA-GG kabul edildi.
  const limitDate = dayjs('2025-02-27');

  // future date check
  if (inputDate.isAfter(today.add(1, 'day'))) {
    return [];
  }

  const dateDiffFromToday = Math.abs(today.diff(inputDate, 'day'));
  const result = [];
  const hasNextDayContent = (inputDate.isSame(today, 'day') || (dateDiffFromToday > 0 && dateDiffFromToday < 6)) && currentHour >= 18;
  if (hasNextDayContent) {
    const tomorrow = today.add(1, 'day');
    const tomorrowName = tomorrow.format('dddd');
    const formattedTomorrowName = tomorrowName.charAt(0).toUpperCase() + tomorrowName.slice(1);

    result.push({
      id: result.length,
      title: formattedTomorrowName,
      date: tomorrow.format('DD.MM.YYYY'),
    });
  }

  // pin today date if input date is close to today
  if (dateDiffFromToday > 0 && dateDiffFromToday < 7) {
    inputDate = dayjs(today.format('YYYY-MM-DD'));
  }

  // create remaining days from the input date
  const dayCount = hasNextDayContent ? 6 : 7;
  for (let id = 0; id < dayCount; id++) {
    const currentDay = inputDate.subtract(id, 'day');

    // filter days before the limit date
    if (currentDay.isBefore(limitDate)) {
      continue;
    }

    // get day name
    const dayName = currentDay.format('dddd');
    // capitalize first letter
    const formattedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
    // format date to DD.MM.YYYY
    const formattedDate = currentDay.format('DD.MM.YYYY');
    result.unshift({
      id: result.length,
      title: formattedDayName,
      date: formattedDate,
    });
  }

  return result;
};

// get year
const getYear = (dateStr) => {
  const date = dayjs(dateStr.split('.').reverse().join('-'));
  return date.format('YYYY');
};

// get month year
const getMonthYear = (dateStr) => {
  const date = dayjs(dateStr.split('.').reverse().join('-'));
  return date.format('MM.YYYY');
};

// get week range
const getWeekRange = (dateStr) => {
  const date = dayjs(dateStr.split('.').reverse().join('-'));
  const startOfWeek = date.startOf('isoWeek');
  const endOfWeek = date.endOf('isoWeek');
  const startDateFormatted = startOfWeek.format('DD.MM.YYYY');
  const endDateFormatted = endOfWeek.format('DD.MM.YYYY');
  return `${startDateFormatted}-${endDateFormatted}`;
};

export const getFrequencyDetails = (freq, horoscope) => {
  const dateText = dayjs().format('DD.MM.YYYY');
  const cards = {
    daily: {
      title: `Günlük ${getHoroscopeName(horoscope)} Burcu Yorumu`,
      image: '/images/astrology/gunluk-yorum.png',
      background: 'linear-gradient(135deg, #FFB6C1 0%, #800080 100%)',
      url: createHoroscopeUrl({ horoscope: horoscope, date: dateText, frequency: 'daily', type: 'general' }),
    },
    weekly: {
      title: `Haftalık ${getHoroscopeName(horoscope)} Burcu Yorumu`,
      image: '/images/astrology/haftalik-yorum.png',
      background: 'linear-gradient(135deg, #00FF7F 0%, #00CED1 100%)',
      url: createHoroscopeUrl({ horoscope: horoscope, date: getWeekRange(dateText), frequency: 'weekly', type: 'general' }),
    },
    monthly: {
      title: `Aylık ${getHoroscopeName(horoscope)} Burcu Yorumu`,
      image: '/images/astrology/aylik-yorum.png',
      background: 'linear-gradient(135deg, #E6E9F0 0%, #1E90FF 100%)',
      url: createHoroscopeUrl({ horoscope: horoscope, date: getMonthYear(dateText), frequency: 'monthly', type: 'general' }),
    },
    yearly: {
      title: `Yıllık ${getHoroscopeName(horoscope)} Burcu Yorumu`,
      image: '/images/astrology/yillik-yorum.png',
      background: 'linear-gradient(135deg, #FF1493 0%, #FF4500 100%)',
      url: createHoroscopeUrl({ horoscope: horoscope, date: getYear(dateText), frequency: 'yearly', type: 'general' }),
    },
  };
  return cards[freq];
};

export const getCtaDetails = (frequency, horoscope, type) => {
  const dateText = dayjs().format('DD.MM.YYYY');
  let date;
  if (frequency === 'daily') {
    date = dateText;
  } else if (frequency === 'weekly') {
    date = getWeekRange(dateText);
  } else if (frequency === 'monthly') {
    date = getMonthYear(dateText);
  } else if (frequency === 'yearly') {
    date = getYear(dateText);
  }

  const dateTextMap = {
    daily: { short: 'gün', long: 'Bugün', sentence: 'Bugün', frequency: 'günlük' },
    weekly: { short: 'hafta', long: 'Bu Hafta', sentence: 'Bu hafta', frequency: 'haftalık' },
    monthly: { short: 'ay', long: 'Bu Ay', sentence: 'Bu ay', frequency: 'aylık' },
    yearly: { short: 'yıl', long: 'Bu Yıl', sentence: 'Bu yıl', frequency: 'yıllık' },
  };

  const dateTextShort = dateTextMap[frequency].short;
  const dateTextLong = dateTextMap[frequency].long;
  const dateTextSentence = dateTextMap[frequency].sentence;
  const dateTextFrequency = dateTextMap[frequency].frequency;

  const link = createHoroscopeUrl({ horoscope, date, frequency, type });

  const cards = {
    general: {
      title: `${dateTextLong} Hayatında Neler Olacak? Hemen Öğren! 🌟`,
      description: `burcu için yeni fırsatlar kapıda mı? 🌈 ${dateTextSentence} duyguların yoğun mu olacak, yoksa biraz sabır mı gerekecek? 🧐`,
      subDescription: `Hemen ${dateTextFrequency} burç yorumunu oku ve seni nelerin beklediğini keşfet!`,
      link,
    },
    love: {
      title: `${dateTextLong} Aşk Hayatında Neler Olacak? Hemen Öğren! 💖`,
      description: `burcu için aşk kapıda mı? 💌 ${dateTextSentence} duyguların yoğun mu olacak, yoksa biraz sabır mı gerekecek? 🧐`,
      subDescription: `Hemen ${dateTextFrequency} aşk burcu yorumunu oku ve kalbini neyin beklediğini keşfet!`,
      link,
    },
    health: {
      title: `Sağlığın İçin ${dateTextLong} Dikkat Etmen Gerekenler! 🏥`,
      description: `burcu için sağlık açısından nasıl bir ${dateTextShort} olacak? 🌿 Enerjin yüksek mi yoksa dinlenmen mi gerekiyor? 💆‍♀️`,
      subDescription: `Hemen ${dateTextFrequency} sağlık burcu yorumunu oku ve kendine en iyi şekilde bak!`,
      link,
    },
    money: {
      title: `${dateTextLong} Finansal Hayatında Neler Olacak? Hemen Öğren! 💰`,
      description: `burcu için para kapıda mı? 💰 ${dateTextSentence} finansal durumun yoğun mu olacak, yoksa biraz sabır mı gerekecek? 🧐`,
      subDescription: `Hemen ${dateTextFrequency} para burcu yorumunu oku ve cüzdanını neyin beklediğini keşfet!`,
      link,
    },
  };
  return cards[type];
};

// popular astrology cards
export const popularAstrologyCards = [
  {
    title: 'TAROT FALI',
    description: 'Geleceğinizi kartlarla keşfedin, sırları çözün.',
    image: '/images/astrology/tarot-fali.png',
    imageClass: '-bottom-8 -right-4 w-[150px] h-auto',
    href: getDailyTarotUrl(),
  },
  {
    title: 'BURÇ UYUMU',
    description: 'Aşk uyumunuzu gösteren yıldız rehberi.',
    image: '/images/astrology/burc-uyumu.png',
    imageClass: 'h-[124px] -bottom-2 right-0',
    href: '/astroloji/burc-uyumu-hesaplama',
  },
  {
    title: 'YÜKSELEN HESAPLAMA',
    description: 'Kişiliğinizin dışa yansıyan gizli yönü.',
    image: '/images/astrology/yukselen-hesaplama.png',
    imageClass: '-bottom-16 right-0 w-[150px] h-auto',
    href: '/astroloji/yukselen-burc-hesaplama',
  },
  {
    title: 'BURÇ YORUMU',
    description: 'Burç karakterinizin sihirli özeti.',
    image: '/images/astrology/burc-ozellikleri.png',
    imageClass: 'h-[124px] -bottom-5 right-0',
    href: createHoroscopeUrl({ horoscope: 'aries', date: dayjs().format('DD.MM.YYYY'), frequency: 'daily', type: 'general' }),
  },
];

// return card image url
export const getHoroscopeImageUrl = (name, isDark = false) => {
  return `https://static-onedio.s3.eu-west-1.amazonaws.com/astroloji/${name}${isDark ? '-dark' : ''}.png`;
};

export const getHoroscopeCompatibilityUrl = (horoscope1, horoscope2) => {
  return `/astroloji/${horoscope1}-${horoscope2}-burc-uyumu`;
};

// send dmp request for gender data
// gender: MALE, FEMALE
export const sendDMPRequest = (gender) => {
  (function (p) {
    p.src = `//dmp.adform.net/dmp/profile/?pid=10548&sg=${gender}%20-%20FCAP2`;
    p.style.display = 'none';
  })(document.createElement('img'));
};
